import NavbarAdmin from "./NavbarAdmin";

export default function GuestNavbar(props) {
  return <NavbarAdmin {...props} />;
}
